// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","455":"631f85d9","977":"d09af86f"}[chunkId] + ".chunk.js";
};